/* DDT Made Theme — ddtmade.js */

(function () {
  'use strict';

  // ─── Theme Toggle ───────────────────────────────────────────
  const THEME_KEY = 'ddt-theme';

  function getStoredTheme() {
    return localStorage.getItem(THEME_KEY) || 'dark';
  }

  function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(THEME_KEY, theme);
    const btn = document.getElementById('theme-toggle');
    if (!btn) return;
    const icon = btn.querySelector('.toggle-icon');
    const label = btn.querySelector('.toggle-label');
    if (theme === 'light') {
      if (icon) icon.innerHTML = moonSVG();
      if (label) label.textContent = 'DARK';
    } else {
      if (icon) icon.innerHTML = sunSVG();
      if (label) label.textContent = 'LIGHT';
    }
  }

  function sunSVG() {
    return `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="12" y1="21" x2="12" y2="23" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="1" y1="12" x2="3" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="21" y1="12" x2="23" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`;
  }

  function moonSVG() {
    return `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M21 12.79A9 9 0 1 1 11.21 3a7 7 0 0 0 9.79 9.79z"/></svg>`;
  }

  // ─── Cart Drawer ─────────────────────────────────────────────
  function openCart() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-overlay');
    if (drawer) drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }

  function closeCart() {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-overlay');
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  // ─── Mobile Menu ─────────────────────────────────────────────
  function initMobileMenu() {
    const toggle = document.getElementById('mobile-menu-toggle');
    const nav = document.getElementById('mobile-nav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', () => {
      nav.classList.toggle('is-open');
    });
  }

  // ─── Header Search ───────────────────────────────────────────
  function initHeaderSearch() {
    const wrapper = document.querySelector('.header-search');
    const toggleBtn = document.getElementById('search-toggle');
    const input = document.getElementById('header-search-input');
    if (!wrapper || !toggleBtn || !input) return;

    function openSearch() {
      wrapper.classList.add('is-open');
      toggleBtn.setAttribute('aria-expanded', 'true');
      window.setTimeout(() => input.focus(), 50);
    }

    function closeSearch() {
      wrapper.classList.remove('is-open');
      toggleBtn.setAttribute('aria-expanded', 'false');
    }

    toggleBtn.addEventListener('click', () => {
      if (wrapper.classList.contains('is-open')) {
        closeSearch();
      } else {
        openSearch();
      }
    });

    document.addEventListener('click', (e) => {
      if (!wrapper.contains(e.target)) closeSearch();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeSearch();
    });
  }

  // ─── Product Gallery ─────────────────────────────────────────
  function initGallery() {
    const main = document.getElementById('gallery-main-img');
    const thumbs = document.querySelectorAll('.product-gallery__thumb');
    if (!main || !thumbs.length) return;

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-src');
        if (src) {
          main.src = src;
          thumbs.forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        }
      });
    });
  }

  // ─── Quantity Selector ───────────────────────────────────────
  function initQtySelectors() {
    document.querySelectorAll('.qty-selector').forEach(selector => {
      const input = selector.querySelector('input');
      const dec = selector.querySelector('[data-action="dec"]');
      const inc = selector.querySelector('[data-action="inc"]');
      if (!input) return;
      dec && dec.addEventListener('click', () => {
        const v = parseInt(input.value) || 1;
        if (v > 1) input.value = v - 1;
      });
      inc && inc.addEventListener('click', () => {
        const v = parseInt(input.value) || 1;
        input.value = v + 1;
      });
    });
  }

  // ─── Variant Selector ────────────────────────────────────────
  function initVariants() {
    document.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.closest('[data-variant-group]');
        if (group) {
          group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('is-active'));
        }
        btn.classList.add('is-active');
        const variantId = btn.getAttribute('data-variant-id');
        const hiddenInput = document.getElementById('variant-id');
        if (hiddenInput && variantId) hiddenInput.value = variantId;
      });
    });
  }

  // ─── Add to Cart ─────────────────────────────────────────────
  function initAddToCart() {
    const form = document.getElementById('product-form');
    if (!form) return;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const variantId = form.querySelector('#variant-id')?.value;
      const qty = form.querySelector('[name="quantity"]')?.value || 1;
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'ADDING...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: parseInt(qty) })
        });
        if (res.ok) {
          await updateCartCount();
          openCart();
          await refreshCartDrawer();
        }
      } catch (err) {
        console.error('Add to cart error:', err);
      } finally {
        btn.disabled = false;
        btn.textContent = 'ADD TO CART';
      }
    });
  }

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const badge = document.getElementById('cart-count');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    } catch (err) { console.error(err); }
  }

  async function changeLineQuantity(lineKey, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity })
      });
      if (!res.ok) {
        console.error('Cart change failed:', res.status);
        return null;
      }
      const cart = await res.json();
      await updateCartCount();
      await refreshCartDrawer();
      return cart;
    } catch (err) {
      console.error('Cart change error:', err);
      return null;
    }
  }

  // Wires +/- and remove buttons inside `container` using event delegation
  // (so it keeps working after refreshCartDrawer replaces the drawer's DOM).
  // `onChange`, if given, receives the updated cart plus the row/lineKey that changed.
  function initCartItemControls(container, onChange) {
    if (!container) return;

    container.addEventListener('click', async (e) => {
      const row = e.target.closest('.cart-item');
      if (!row) return;
      const lineKey = row.dataset.lineKey;
      if (!lineKey) return;

      let quantity = null;
      if (e.target.closest('[data-remove-item]')) {
        quantity = 0;
      } else if (e.target.closest('[data-qty-increase]')) {
        const currentQty = parseInt(row.querySelector('.cart-item__qty-value').textContent, 10);
        quantity = currentQty + 1;
      } else if (e.target.closest('[data-qty-decrease]')) {
        const currentQty = parseInt(row.querySelector('.cart-item__qty-value').textContent, 10);
        quantity = Math.max(0, currentQty - 1);
      }
      if (quantity === null) return;

      const cart = await changeLineQuantity(lineKey, quantity);
      if (cart && onChange) onChange(cart, row, lineKey);
    });
  }

  // Patches the full /cart page in place after a quantity/remove change,
  // instead of re-rendering the whole list like the drawer does.
  function updateCartPageRow(cart, row, lineKey) {
    if (cart.item_count === 0) {
      window.location.reload();
      return;
    }
    const line = cart.items.find(i => i.key === lineKey);
    if (!line) {
      row.remove();
    } else {
      const qtyEl = row.querySelector('.cart-item__qty-value');
      if (qtyEl) qtyEl.textContent = line.quantity;
      const priceEl = row.querySelector('.cart-item__price');
      if (priceEl) priceEl.textContent = formatMoney(line.final_line_price);
    }
    const subtotalEl = document.getElementById('cart-page-subtotal');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  async function refreshCartDrawer() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const itemsEl = document.getElementById('cart-items');
      const subtotalEl = document.getElementById('cart-subtotal');
      if (!itemsEl) return;

      if (cart.items.length === 0) {
        itemsEl.innerHTML = '<div class="empty-state"><h3>YOUR CART IS EMPTY</h3><p>Find something worth cutting.</p></div>';
      } else {
        itemsEl.innerHTML = cart.items.map(item => `
          <div class="cart-item" data-line-key="${item.key}">
            <div class="cart-item__image">
              ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
            </div>
            <div class="cart-item__details">
              <div class="cart-item__title">${item.product_title}</div>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
              <div class="cart-item__price">${formatMoney(item.line_price)}</div>
              <div class="cart-item__controls">
                <div class="cart-item__qty">
                  <button type="button" class="cart-item__qty-btn" data-qty-decrease aria-label="Decrease quantity">&minus;</button>
                  <span class="cart-item__qty-value">${item.quantity}</span>
                  <button type="button" class="cart-item__qty-btn" data-qty-increase aria-label="Increase quantity">+</button>
                </div>
                <button type="button" class="cart-item__remove" data-remove-item aria-label="Remove ${item.product_title} from cart">Remove</button>
              </div>
            </div>
          </div>
        `).join('');
      }

      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    } catch (err) { console.error(err); }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ─── Scroll Animations ───────────────────────────────────────
  function initScrollAnimations() {
    if (!window.IntersectionObserver) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));
  }

  // ─── Init ─────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    // Theme
    applyTheme(getStoredTheme());

    const toggleBtn = document.getElementById('theme-toggle');
    if (toggleBtn) {
      toggleBtn.addEventListener('click', () => {
        const current = document.documentElement.getAttribute('data-theme') || 'dark';
        applyTheme(current === 'dark' ? 'light' : 'dark');
      });
    }

    // Cart
    document.getElementById('cart-icon')?.addEventListener('click', openCart);
    document.getElementById('cart-close')?.addEventListener('click', closeCart);
    document.getElementById('cart-overlay')?.addEventListener('click', closeCart);
    initCartItemControls(document.getElementById('cart-items'));
    initCartItemControls(document.getElementById('cart-page-items'), updateCartPageRow);
    updateCartCount();

    // Features
    initMobileMenu();
    initHeaderSearch();
    initGallery();
    initQtySelectors();
    initVariants();
    initAddToCart();
    initScrollAnimations();
  });
})();
